import React from 'react';

function UsersMailboxPage() {
    return <div>Users Mailbox Page</div>;
}

export default UsersMailboxPage;
